import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { flatMap } from 'lodash';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount, switchMap, withLatestFrom } from 'rxjs/operators';
import { UrlBuilder } from '../../core';
import { CategoriesStorage, Category, CategoryNaturalKey, TabCategory } from '../../documents';
import { SponsorRouteData } from '../sponsor-route-data';

@Component({
    selector: 'study-documents',
    template: require('../../shared/tabs.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudyDocumentsComponent implements OnInit {
    public tabsCategories: Observable<TabCategory[]>;

    constructor(
        private readonly routeData: SponsorRouteData,
        private readonly urlBuilder: UrlBuilder,
        private readonly categoriesStorage: CategoriesStorage
    ) { }

    public ngOnInit() {
        this.tabsCategories = this.createTabs();
    }

    private createTabs(): Observable<TabCategory[]> {
        const selectedStudy = this.routeData.snapshot.selectedStudy;
        
        const permissions$ = this.routeData.studyPermissions;
        
        const allowedCategories$ = permissions$.pipe(
            withLatestFrom(this.categoriesStorage.studyDocumentsCategories),
            map(([permissions, categories]) => categories.filter(c => permissions.canViewCategory(c.categoryId)))
        );

        const tabs$ = allowedCategories$.pipe(
            map(subCategories => {
                const tabs = subCategories.map((subCategory: Category) => {
                    const url = this.urlBuilder
                        .esa()
                        .sponsor()
                        .study(selectedStudy)
                        .studyDocuments(subCategory)
                        .url();

                    return { name: this.getTabName(subCategory), url } as TabCategory;
                });

                return tabs;
            }));

        return tabs$.pipe(
            publishReplay(1),
            refCount()
        );
    }

    private getTabName(category: Category) {
        if (category.categoryId === 'lab-manuals-others') {
            return 'Other Manuals';
        }
        if (category.categoryId === 'training-materials-others') {
            return 'Other Training Materials';
        }
        return category.name;
    }
}
